module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"Backbone","amd":"backbone","commonjs":"backbone","commonjs2":"backbone"}
 ** module id = 3
 ** module chunks = 0
 **/